import { UseMutationResult } from "@tanstack/react-query";
import { Button, Card, Input } from "@rumbledirect/ui";
import { Flex, Form } from "antd";
import { useEffect } from "react";
import { FAQ } from "@rumble-it/common-lib/types/models/FAQ.interface";
import { Media } from "@rumble-it/common-lib/types/models/Media.interface";
import { DocumentUpload } from "@/components/form/DocumentUpload";

export type FaqInputDto = Omit<FAQ, "id" | "media"> & {
  media?: string[]; // Array of media IDs
};

type FaqFormValues = Omit<FAQ, "id" | "media"> & {
  media?: Media[]; // Form returns Media objects from DocumentUpload
};

interface FaqFormCardProps {
  mutation: UseMutationResult<FAQ | null, Error, FaqInputDto, unknown>;
  initialValues?: FAQ;
  loading?: boolean;
  title?: string;
  buttonText?: string;
}

export const FaqFormCard = ({
  mutation,
  initialValues,
  title = "Vraag & antwoord aanmaken",
  buttonText = "Aanmaken",
  loading = false,
}: FaqFormCardProps) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(initialValues);
  }, [form, initialValues]);

  const handleFinish = (values: FaqFormValues) => {
    const mediaIds = values.media?.map((media) => media.id) || [];

    const payload: FaqInputDto = {
      question: values.question,
      answer: values.answer,
      media: mediaIds,
    };

    mutation.mutate(payload);
  };

  return (
    <Form form={form} onFinish={handleFinish} layout="vertical">
      <Flex vertical gap={16}>
        <Card loading={loading} title={title}>
          <Form.Item
            rules={[{ required: true, message: "Dit veld is verplicht" }]}
            label="Vraag"
            name="question"
          >
            <Input />
          </Form.Item>
          <Form.Item
            rules={[{ required: true, message: "Dit veld is verplicht" }]}
            label="Antwoord"
            name="answer"
          >
            <Input.TextArea />
          </Form.Item>
          <Form.Item label="PDF" name="media">
            <DocumentUpload multiple />
          </Form.Item>
          <Form.Item label={null}>
            <Button
              loading={mutation.isPending}
              type="primary"
              htmlType="submit"
            >
              {buttonText}
            </Button>
          </Form.Item>
        </Card>
      </Flex>
    </Form>
  );
};
